import script from "./Grades.vue?vue&type=script&setup=true&lang=js"
export * from "./Grades.vue?vue&type=script&setup=true&lang=js"

import "./Grades.vue?vue&type=style&index=0&id=47fb025b&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47fb025b"]])

export default __exports__